<template>
  <b-card-code title="جدول الاخبار" no-body>
    <b-card-body>
      <div class="d-flex justify-content-between flex-wrap">
        <!-- filter -->
        <b-form-group
          label="فلتر"
          label-cols-sm="1"
          label-align-sm="left"
          label-size="sm"
          label-for="filterInput"
          class="mb-0"
        >
          <b-input-group size="md">
            <b-form-input
              id="filterInput"
              v-model="title"
              type="search"
              placeholder="ابحث عن.."
            />
            <v-select v-if="role"
              v-model="department"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="title"
              :options="departments"
              placeholder="اختر القسم"
            />
            <b-input-group-append>
              <b-button @click="resetSearch()"> الغاء الفلتر </b-button>
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                v-b-modal.model-a-w
              >
                <feather-icon icon="FilePlusIcon" class="mr-50" />
                <span class="align-middle">اضافة خبر جديد</span>
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
        
          <b-form-group v-if="role">
            <b-form-checkbox-group
              id="checkbox-group-2"
              v-model="slider"
              name="flavour-2"
              class="demo-inline-spacing"
            >
              <b-form-checkbox value="slider"> عرض السلايدات </b-form-checkbox>
            </b-form-checkbox-group>
          </b-form-group>
      </div>
    </b-card-body>
<div class="demo-vertical-spacing">
      <b-progress
      v-if="precentage !== 0"
        :value="precentage"
        max="100"
      />
      </div>
    <b-table
      ref="table"
      striped
      hover
      responsive
      class="position-relative"
      :per-page="perPage"
      :items="items"
      :fields="fields"
    >
      <template #cell(action)="action">
        <b-dropdown
          variant="link"
          no-caret
          :right="$store.state.appConfig.isRTL"
        >
          <template #button-content>
            <feather-icon
              icon="MoreVerticalIcon"
              size="16"
              class="align-middle text-body"
            />
          </template>
          <b-col v-if="action.item.is_aproved==1" md="12">
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="outline-info"
          @click="view(action.item.id)"
        >
          <feather-icon icon="FileTextIcon" class="mr-50" />
          <span class="align-middle">عرض الخبر</span>
        </b-button>
</b-col>
          <b-col md="12">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-warning"
              v-b-modal.model-e-w
              @click="eRM(action.item)"
            >
              <feather-icon icon="EditIcon" class="mr-50" />
            </b-button>
          </b-col>
          <b-col v-if="role" md="12">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-danger"
              v-b-modal.modal-center
              @click="dRM(action.item)"
            >
              <feather-icon icon="Trash2Icon" class="mr-50" />
            </b-button>
          </b-col>
        </b-dropdown>
      </template>
      <template #cell(status)="data">
        <b-badge v-if="data.item.is_aproved==1"
          pill
          :variant="success"
        >
          منشور
        </b-badge>
        <b-badge v-else
          pill
          :variant="waiting"
        >
          قيد النشر
        </b-badge>
      </template>
      <template #cell(image)="image">
        <b-avatar size="lg" :src="getImage(image.item.image)" />
      </template>
    </b-table>

    <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
      <!-- page length -->
      <b-form-group
        label="Per Page"
        label-cols="6"
        label-align="left"
        label-size="sm"
        label-for="sortBySelect"
        class="text-nowrap mb-md-0 mr-1"
      >
        <b-form-select
          id="perPageSelect"
          v-model="perPage"
          @change="check()"
          size="sm"
          inline
          :options="pageOptions"
        />
      </b-form-group>

      <!-- pagination -->
      <b-pagination
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        first-number
        last-number
        prev-class="prev-item"
        next-class="next-item"
        class="mb-0"
        @change="check()"
      >
        <template #prev-text>
          <feather-icon icon="ChevronLeftIcon" size="18" />
        </template>
        <template #next-text>
          <feather-icon icon="ChevronRightIcon" size="18" />
        </template>
      </b-pagination>
    </b-card-body>
    <b-modal
      id="model-e-w"
      ok-title="تعديل البيانات"
      centered
      size="lg"
      title="تعديل البيانات"
      @show="checkModel"
      @hidden="rEF"
      @ok="uM"
    >
      <b-form novalidate class="needs-validation">
        <b-form-row>
          <b-col md="12">
            <label for="input-valid1">العنوان بالعربي:</label>
            <b-form-input
              id="input-valid1"
              v-model="editform.ar_title"
              :state="editform.ar_title.length > 0"
              placeholder="العنوان بالعربي"
            />
          </b-col>
          <b-col md="12">
            <label for="input-valid1">العنوان بالانكليزي:</label>
            <b-form-input
              id="input-valid1"
              v-model="editform.en_title"
              :state="editform.en_title.length > 0"
              placeholder="العنوان بالانكليزي"
            />
          </b-col>

          <b-col md="12">
            <label for="input-invalid1">مختصر للمقالة بالعربي:</label>
            <b-form-input
              id="input-invalid1"
              v-model="editform.ar_sub_description"
              :state="editform.ar_sub_description.length > 0"
              placeholder="مختصر للمقالة بالعربي"
            />
          </b-col>
          <b-col md="12">
            <label for="input-invalid1">مختصر للمقالة بالانكليزي:</label>
            <b-form-input
              id="input-invalid1"
              v-model="editform.en_sub_description"
              :state="editform.en_sub_description.length > 0"
              placeholder="مختصر للمقالة بالانكليزي"
            />
          </b-col>
          <b-col md="12">
            <label for="input-valid1">المقال بالعربي:</label>
            <quill-editor
              ref="editformar_description"
              v-model="editform.ar_description"
              :options="snowOption"
            />
          </b-col>
          <b-col md="12">
            <label for="input-invalid1">المقال بالانكليزي:</label>
            <quill-editor
              ref="editformen_description"
              v-model="editform.en_description"
              :options="snowOption"
            />
          </b-col>
          <b-col v-if="role" md="12">
            <b-form-group>
              <label for="basic-password">القسم</label>
              <v-select
                v-model="editform.department_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="title"
                :options="departments"
                placeholder="select department"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <label for="input-valid1">اختصر الصورة الرئيسية:</label>
            <b-form-file
            placeholder="اختر الملف او اسقطها هنا..."
            drop-placeholder="اختر الملف او اسقطها هنا..."
              v-model="editform.file"
              @change="selectFileForEditForm"
            />
          </b-col>
          <b-col md="12">
            <label for="input-valid1">اختر الصور الاضافية:</label>
            <b-form-file
            placeholder="اختر الملف او اسقطها هنا..."
            drop-placeholder="اختر الملف او اسقطها هنا..."
              multiple
              ref="file"
              v-model="editform.files"
              @change="selectFilesForEditForm"
            />
          </b-col>
          <b-form-group>
            <b-form-checkbox-group
              id="checkbox-group-2"
              v-model="editform.is_slider"
              name="flavour-2"
              class="demo-inline-spacing"
            >
              <b-form-checkbox value="1"> عرض في السلايدات </b-form-checkbox>
            </b-form-checkbox-group>
            <b-form-checkbox-group
              id="checkbox-group-2"
              v-model="editform.is_aproved"
              name="flavour-2"
              class="demo-inline-spacing"
            >
              <b-form-checkbox value="1"> الموافقة على النشر </b-form-checkbox>
            </b-form-checkbox-group>
          </b-form-group>
        </b-form-row>
      </b-form>
    </b-modal>
    <b-modal
      id="model-a-w"
      ok-title="حفظ البيانات"
      centered
      size="lg"
      title="اضافة خبر جديد"
      @show="checkModel"
      @hidden="rF"
      @ok="aNM"
    >
      <b-form novalidate class="needs-validation">
        <b-form-row>
          <b-col md="12">
            <label for="input-valid1">العنوان بالعربي:</label>
            <b-form-input
              id="input-valid1"
              v-model="form.ar_title"
              :state="form.ar_title.length > 0"
              placeholder="العنوان بالعربي"
            />
          </b-col>
          <b-col md="12">
            <label for="input-valid1">العنوان بالانكليزي:</label>
            <b-form-input
              id="input-valid1"
              v-model="form.en_title"
              :state="form.en_title.length > 0"
              placeholder="العنوان بالانكليزي"
            />
          </b-col>

          <b-col md="12">
            <label for="input-invalid1">مختصر للمقالة بالعربي:</label>
            <b-form-input
              id="input-invalid1"
              v-model="form.ar_sub_description"
              :state="form.ar_sub_description.length > 0"
              placeholder="مختصر للمقالة بالعربي"
            />
          </b-col>
          <b-col md="12">
            <label for="input-invalid1">مختصر للمقالة بالانكليزي:</label>
            <b-form-input
              id="input-invalid1"
              v-model="form.en_sub_description"
              :state="form.en_sub_description.length > 0"
              placeholder="مختصر للمقالة بالانكليزي"
            />
          </b-col>
          <b-col md="12">
            <label for="input-valid1">المقال بالعربي:</label>
            <quill-editor
              ref="formar_description"
              v-model="form.ar_description"
              :options="snowOption"
            />
          </b-col>
          <b-col md="12">
            <label for="input-invalid1">المقال بالانكليزي:</label>
            <quill-editor
              ref="formen_description"
              v-model="form.en_description"
              :options="snowOption"
            />
          </b-col>
          <b-col v-if="role" md="12">
            <b-form-group>
              <label for="basic-password">القسم</label>
              <v-select
                v-model="form.department_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="title"
                :options="departments"
                placeholder="اختر القسم"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <label for="input-valid1">اختصر الصورة الرئيسية:</label>
            <b-form-file
            placeholder="اختر الملف او اسقطها هنا..."
            drop-placeholder="اختر الملف او اسقطها هنا..."
              v-model="form.file"
              @change="selectFileForForm"
            />
          </b-col>
          <b-col md="12">
            <label for="input-valid1">اختر الصور الاضافية:</label>
            <b-form-file
            placeholder="اختر الملف او اسقطها هنا..."
            drop-placeholder="اختر الملف او اسقطها هنا..."
              multiple
              ref="file"
              v-model="form.files"
              @change="selectFilesForForm"
            />
          </b-col>
          <b-col md="12">
            <label for="input-valid1">تاكز:</label>
            <b-form-tags v-model="form.tags" input-id="tags-basic" class="mb-2" />
          </b-col>
          <b-form-group>
            <b-form-checkbox-group
              id="checkbox-group-2"
              v-model="selected"
              name="flavour-2"
              class="demo-inline-spacing"
            >
              <b-form-checkbox value="1"> عرض في السلايدات </b-form-checkbox>
            </b-form-checkbox-group>
          </b-form-group>
        </b-form-row>
      </b-form>
    </b-modal>

    <b-modal
      id="modal-center"
      centered
      title="Delete User"
      @ok="dM"
      ok-title="Accept"
    >
      <b-card-text>
        هل تريد حذف هذه الحقل " {{ this.editform.ar_title }} "
        ?
      </b-card-text>
    </b-modal>
  </b-card-code>
</template>

<script>
import vSelect from "vue-select";
import store from "@/store";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import { filesUrl } from "@/main.js";
import BCardCode from "@core/components/b-card-code/BCardCode.vue";
import {
  BTable,
  BFormTags,
  BAvatar,
  BModal,
  BDropdown,
  BDropdownItem,
  BFormCheckboxGroup,
  BForm,
  BFormRow,
  BCol,
  VBModal,
  BFormValidFeedback,
  BFormInvalidFeedback,
  BFormGroup,
  BFormCheckbox,
  BCardText,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BCardBody,
  BBadge,BProgress,
  BFormFile,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { quillEditor } from "vue-quill-editor";
export default {
  components: {
    BCardCode,
    BTable,
    BForm,
    quillEditor,
    vSelect,
    BAvatar,
    BFormTags,
    BFormRow,
    BDropdown,
    filesUrl,BProgress,
    BDropdownItem,
    BFormGroup,
    togglePasswordVisibility,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormCheckboxGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BCardBody,
    BModal,BBadge,
    VBModal,
    Ripple,
    BCol,
    BFormCheckbox,
    BCardText,
    BFormValidFeedback,
    BFormInvalidFeedback,
    BFormFile,
  },
  data() {
    return {
      precentage:0,
      teacher_id: "",
      perPage: 3,
      pageOptions: [3, 5, 10, 100],
      totalRows: 1,
      currentPage: 0,
      department: "",
      title: "",
      success: 'success',
      waiting: 'warning',
      role:"",
      filter: null,
      filterOn: [],
      departments: [],
      teachers: [],
      stages: [],
      is_journal:false,
      fields: [
        {
          key: "ar_title",
          label: "العنوان بالعربي",
        },
        {
          key: "en_title",
          label: "العنوان بالانكليزي",
        },
        {
          key: "user.full_name",
          label: "الناشر",
        },
        {
          key: "department.ar_name",
          label: "القسم",
        },
        { key: "views", label: "زيارات " },
        { key: "status", label: "منشور؟ " },
        { key: "image", label: "الصورة  " },
        { key: "action", label: "الاجراءات" },
      ],
      items: [],
      notifi: {
        route: "",
        title: "",
        item_id: "",
        table: "",
        users: [],
        departments: [],
        role_id: "",
        type: "",
        subtitle: "",
        bg: "",
      },
      form: {
        en_title: "",
        ar_title: "",
        file: "",
        files: [],
        tags: [],
        ar_description: "",
        en_description: "",
        ar_sub_description: "",
        en_sub_description: "",
        department_id: "",
        is_aproved:0, 
        is_slider: 0,
        tags: [],
      },
      editform: {
        en_title: "",
        ar_title: "",
        file: "",
        files: [],
        tags: [],
        ar_description: "",
        en_description: "",
        ar_sub_description: "",
        en_sub_description: "",
        department_id: "",
        is_slider: 0,
        is_aproved:0,
        id: null,
      },
      selected: [],
      selected2: "",
      formModal: {},
      snowOption: {
        theme: "snow",
      },
      slider:"",
    };
  },
  watch: {
    department: function (val) {
      this.gS();
    },
    title: function (val) {
      this.gS();
    },
    slider: function (val) {
      this.gS();
    },
    "$route.params.id": {
      handler: function (search) {
        this.gS();
      },
    },
    // "editform.is_slider": function (val) {
    //   if (this.selected2=='slider') {
    //     this.editform.is_slider = 1
    //       console.log(this.editform.is_slider)
    //     }else{
    //     this.editform.is_slider = 0
    //      console.log(this.editform.is_slider)
    //     }
        
    // },
    "editform.ar_description": function (val) {
      this.formModal.ar_edit = JSON.stringify(
        this.$refs.editformar_description.quill.getContents()
      );
    },
    "editform.en_description": function (val) {
      this.formModal.en_edit = JSON.stringify(
        this.$refs.editformen_description.quill.getContents()
      );
    },
    "form.ar_description": function (val) {
      this.formModal.ar_description = JSON.stringify(
        this.$refs.formar_description.quill.getContents()
      );
    },
    "form.en_description": function (val) {
      this.formModal.en_description = JSON.stringify(
        this.$refs.formen_description.quill.getContents()
      );
    },
  },
  mixins: [togglePasswordVisibility],
  directives: {
    Ripple,
  },
  mounted() {
    if(localStorage.getItem("NisourRole")=="admin"){
      this.role = true
    }else{
            this.role = false
    }
    if(localStorage.getItem("NisourRole")=="journal"){
      this.is_journal = true
    }
    this.ID(), this.gS(), this.gSM();
  },
  methods: {
    async gSM() {
      await this.axios
        .get(
          `since/deparment?take=${this.perPage}&skip=${
            this.currentPage - 1
          }&select=true`
        )
        .then((res) => {
          this.departments = [];
          this.departments = res.data.items;
        })
        .catch((e) => {
          if (e.message.includes("401")) {
            this.makeToast(
              "danger",
              "update failed",
              "you don't a permision to do this action ;)"
            );
          } else {
            this.errorToast();
          }
        });
    },
    checkModel() {
      this.selected = [];
    },
    resetCheckboxes() {
      this.selected = [];
    },
    async uM() {
      if (isNaN(this.editform.department_id) && this.editform.department_id!="" && this.editform.department_id!=null) {
        this.editform.department_id = this.editform.department_id["id"];
      }
      let data = new FormData();
      data.append("en_title", this.editform.en_title);
      data.append("ar_title", this.editform.ar_title);
      data.append("ar_description",this.formModal.ar_edit);
      data.append("en_description", this.formModal.en_edit);
      data.append("ar_sub_description", this.editform.ar_sub_description);
      data.append("en_sub_description", this.editform.en_sub_description);
      if(this.editform.department_id){
      data.append("department_id", this.editform.department_id);
      }
      data.append("is_slider", this.editform.is_slider);
      if(this.editform.is_aproved == false){
      data.append("is_aproved", 0);
      }else{
      data.append("is_aproved", this.editform.is_aproved);
      }
      data.append("image", this.editform.file);
      if(this.editform.files.length>0){
        this.editform.files.forEach((element) =>
        data.append("images[]", element)
      );
      }
      await this.axios
        .post(`news/${this.editform.id}`, data,{
          onUploadProgress: progressEvent => {
            this.precentage =
              (progressEvent.loaded / progressEvent.total) * 100;
          }
        })
        .then((res) => {
          if (res.data.errors) {
            this.errorToast();
          } else {
            this.gS();
            this.makeToast(
              "success",
              "update Success",
              "Your update is done successfully"
            );
            this.notifi.route = "news-notif";
            this.notifi.title = "update action";
            this.notifi.item_id = res.data.data.id;
            this.notifi.table = "news";
            this.notifi.role_id = 1;
            this.notifi.type = "light-worning";
            this.notifi.subtitle = "updated news";
            this.notifi.bg = "bg-worning";
            this.sendNoti();
          }
          this.precentage=0
        })
        .catch((e) => {
          if (e.message.includes("401")) {
            this.makeToast(
              "warning",
              "update failed",
              "you don't a permision to do this action ;)"
            );
          } else {
            this.errorToast();
          }
        });
    
    },
    async aNM() { 

      if (isNaN(this.form.department_id)) {
        this.form.department_id = this.form.department_id["id"];
      }
      else{
        this.form.department_id = localStorage.getItem("NisourDepartmentId")
      }

      let data = new FormData();
      data.append("en_title", this.form.en_title);
      data.append("ar_title", this.form.ar_title);
      data.append("ar_description", this.formModal.ar_description);
      data.append("en_description", this.formModal.en_description);
      data.append("ar_sub_description", this.form.ar_sub_description);
      data.append("en_sub_description", this.form.en_sub_description);
      if(this.form.department_id){
      data.append("department_id", this.form.department_id);
      }
      data.append("is_slider", this.form.is_slider);
      data.append("is_aproved", this.form.is_aproved);
      data.append("tags", this.form.tags);
      data.append("image", this.form.file);
      if(this.form.files.length>0){
      this.form.files.forEach((element) => data.append("images[]", element));
      }
      if(this.form.tags.length>0){
      this.form.tags.forEach((element) => data.append("tags[]", element));
      }
      await this.axios
        .post(`news`, data,{
          onUploadProgress: progressEvent => {
            this.precentage =
              (progressEvent.loaded / progressEvent.total) * 100;
          }
        })
        .then((res) => {
          if (res.data.errors) {
            this.errorToast();
          } else {
            this.gS();
            this.makeToast(
              "success",
              "update Success",
              "Your model is added successfully"
            );
            this.notifi.route = "news-notif";
            this.notifi.title = "add action";
            this.notifi.item_id = res.data.data.id;
            this.notifi.table = "news";
            this.notifi.role_id = 1;
            this.notifi.type = "light-Success";
            this.notifi.subtitle = "added a new news";
            this.notifi.bg = "bg-success";
            this.sendNoti();
          }
          this.rF();
          this.precentage=0
        })
        .catch((e) => {
          if (e.message.includes("401")) {
            this.makeToast(
              "warning",
              "update failed",
              "you don't a permision to do this action ;)"
            );
          } else {
            this.errorToast();
          }
        });
      this.rF();
    }, 
    rF() {
      (this.form.en_title = ""),
        (this.form.ar_title = ""),
        (this.form.file = ""),
        (this.form.files = []),
        (this.form.tags = []),
        (this.form.ar_description = ""),
        (this.form.en_description = ""),
        (this.form.ar_sub_description = ""),
        (this.form.en_sub_description = ""),
        (this.form.department_id = 0),
        (this.form.is_aproved = 0),
        (this.form.formModal = {}),
        (this.form.is_slider = "");
    },
    rEF() {
      (this.editform.en_title = ""),
        (this.editform.ar_title = ""),
        (this.editform.file = []),
        (this.editform.files = ""),
        (this.editform.tags = []),
        (this.editform.ar_description = ""),
        (this.editform.en_description = ""),
        (this.editform.ar_sub_description = ""),
        (this.editform.en_sub_description = ""),
        (this.editform.department_id = ""),
        (this.editform.is_slider = 0),
        (this.editform.is_aproved = 0),
        (this.editform.formModal = {}),
        (this.editform.id = "");
    },
    async sendNoti() {
      await this.axios.post(`notifications`, this.notifi);
    },
    async dM() {
      await this.axios
        .delete(`news/${this.editform.id}`)
        .then((res) => {
          if (res.data.errors) {
            this.errorToast();
          } else {
            this.gS();
            this.makeToast(
              "success",
              "Delete Success",
              "Your item is deleted successfully"
            );
            this.notifi.route = "news-notif";
            this.notifi.title = "delete action";
            this.notifi.item_id = res.data.data.id;
            this.notifi.table = "news";
            this.notifi.role_id = 1;
            this.notifi.type = "light-danger";
            this.notifi.subtitle = "deleted news";
            this.notifi.bg = "bg-danger";
            this.sendNoti();
          }
        })
        .catch((e) => {
          if (e.message.includes("401")) {
            this.makeToast(
              "warning",
              "update failed",
              "you don't a permision to do this action ;)"
            );
          } else {
            this.errorToast();
          }
        });
    },
    errorToast() {
      this.makeToast(
        "danger",
        "update failed",
        "some thing want wrong, i`m sorry :("
      );
    },
    eRM(item) {
      this.editform.en_title = item.en_title;
      this.editform.ar_title = item.ar_title;
      this.editform.ar_description = item.ar_description;
      this.editform.en_description = item.en_description;
      this.editform.tags = item.tags;
      setTimeout(() => {
        
        if (this.editform.ar_description != null) {
          this.formModal.ar_edit = this.editform.ar_description
          this.$refs.editformar_description.quill.setContents(
            JSON.parse(this.editform.ar_description)
          );
        }
        if (this.editform.en_description != null) {
          this.formModal.en_edit = this.editform.en_description
          this.$refs.editformen_description.quill.setContents(
            JSON.parse(this.editform.en_description)
          );
        }
      }, 0);
      this.editform.ar_sub_description = item.ar_sub_description;
      this.editform.en_sub_description = item.en_sub_description;
      this.editform.department_id = item.department_id;
      this.editform.is_slider = item.is_slider;
      this.editform.is_aproved = item.is_aproved;
      this.editform.file = item.image;
      this.editform.id = item.id;
    },
    dRM(item) {
      this.editform.ar_title = item.ar_title;
      this.editform.id = item.id;
    },
    check() {
      setTimeout(() => this.gS(), 1000);
    },
    ID() {
      this.teacher_id = localStorage.getItem("NisourTeacherId");
    },
    async gS() {
      if (isNaN(this.department) & (this.department != "")) {
        this.department = this.department["id"];
      }
      let ch = ""
      if(this.is_journal==true){
        ch=`&is_journal=${true}`
      }
      await this.axios
        .get(
          `news?take=${this.perPage}&skip=${this.currentPage - 1}&department=${
            this.department
          }&title=${this.title}&slider=${this.slider[0]}
          `
        )
        .then((res) => {
          this.items = [];
          this.totalRows = "";
          this.totalRows = res.data.totalCount;
          this.items = res.data.items;
        })
        .catch((e) => {
          if (e.message.includes("401")) {
            this.makeToast(
              "danger",
              "update failed",
              "you don't a permision to do this action ;)"
            );
          } else {
            this.errorToast();
          }
        });
    },
    async gR() {
      await this.axios
        .get(`news?take=${this.perPage}&skip=${this.currentPage - 1}`)
        .then((res) => {
          this.items = [];
          this.totalRows = res.data.totalCount;
          this.items = res.data.items;
        })
        .catch((e) => {
          if (e.message.includes("401")) {
            this.makeToast(
              "danger",
              "update failed",
              "you don't a permision to do this action ;)"
            );
          } else {
            this.errorToast();
          }
        });
    },
    makeToast(variant = null, title = null, body = null) {
      this.$bvToast.toast(body, {
        title: title,
        variant,
        solid: false,
      });
    },
    resetSearch() {
      (this.title = ""), (this.department = "");
      this.gS();
    },
    getImage(path) {
      return `${filesUrl}/${path}`;
    },
    selectFilesForForm(e) {
      this.form.files = [];
      console.log(e.target.files);
      console.log(e.target.files[0]);
      e.target.files.forEach((element) => this.form.files.push(element));
      console.log(this.form.files);
    },
    selectFilesForEditForm(e) {
      this.editform.files = [];
      console.log(e.target.files);
      console.log(e.target.files[0]);
      e.target.files.forEach((element) => this.editform.files.push(element));
      console.log(this.form.files);
    },
    selectFileForForm(e) {
      this.form.files = "";
      console.log(e.target.files);
      console.log(e.target.files[0]);
      this.form.files = e.target.files[0];
      console.log(this.form.files);
    },
    selectFileForEditForm(e) {
      this.editform.file = "";
      console.log(e.target.files);
      console.log(e.target.files[0]);
      this.editform.file = e.target.files[0];
      console.log(this.editform.file);
    },
    view(id) {
      window.open(`https://nuc.edu.iq/blog/${id}`, "_blank");
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/quill.scss";
</style>